import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReactNode, memo } from 'react';
import { View } from 'react-native';

/** A field of a style option: a short label, then its choices. */
export const StyleRow = memo(
  ({ label, children }: { label: string; children: ReactNode }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: rpx(8) }}>
        <Typography.Text
          size={rpx(12)}
          color={aiColors.mutedForeground}
          style={{ width: rpx(56) }}
        >
          {label}
        </Typography.Text>
        <View
          style={{
            flex: 1,
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: rpx(6),
          }}
        >
          {children}
        </View>
      </View>
    );
  },
);
